import React from "react"
import { Link } from "react-router-dom"
import { Settings } from "lucide-react"

function autonomyLabel(t, autonomy) {
  const key = `dashboard.topbar.autonomy_${autonomy || "conservative"}`
  return t("dashboard.topbar.autonomy_label", { label: t(key) })
}

function shopHost(url) {
  if (!url) return ""
  try { return new URL(url).host } catch { return url }
}

export default function Topbar({ t, shop }) {
  const autonomy = shop?.setting?.ai_autonomy || "conservative"
  const initials = shop?.user?.initials || "ME"

  return (
    <header className="border-b border-rule bg-surface-card">
      <div className="px-7 h-[52px] flex items-center justify-between">
        <div className="flex items-center gap-[10px] text-sm">
          <Link to="/" className="text-[15px] tracking-[-0.025em] text-ink-primary">
            ShopShift<span className="text-ai">.</span>
          </Link>
          <span className="text-archived text-base">›</span>
          <span className="font-mono text-[12px] text-ink-secondary">{shopHost(shop?.url)}</span>
        </div>

        <div className="flex items-center gap-4">
          <div
            className="inline-flex items-center gap-2 text-[12px] rounded-pill"
            style={{ background: "#ECFDF5", color: "#047857", padding: "4px 10px 4px 8px" }}
          >
            <span className="w-[6px] h-[6px] rounded-full bg-winner-dot" />
            <span className="font-medium">{autonomyLabel(t, autonomy)}</span>
          </div>

          <Link to="/settings" aria-label="Settings" className="text-ink-tertiary hover:text-ink-primary">
            <Settings size={15} strokeWidth={1.75} />
          </Link>

          <div className="w-7 h-7 rounded-[4px] bg-brand inline-flex items-center justify-center text-[11px] font-medium text-ink-on-dark">
            {initials}
          </div>
        </div>
      </div>
    </header>
  )
}
